export default __webpack_public_path__ + "static/media/CodePen-404-Page.a4d44b49.gif";